import axios from "axios";
import { useEffect, useState } from "react";
import { FaUserCheck } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import { GiTakeMyMoney } from "react-icons/gi";
import { GrNotes } from "react-icons/gr";
import { LIVE_URL } from "../../../config/config";
import useAuthToken from "../../../hooks/useAuthToken";
import bgImage from "../../assets/images.jpg";
import styles from "./css/Dashboard.module.scss";
import UserStatistics from "./UserStatistics";

const Dashboard = () => {
  // Custom hook to get auth token and loading state
  const { token, loading } = useAuthToken();

  // State to store the fetched dashboard data
  const [dashboardData, setDashboardData] = useState({
    users: 0,
    active_users: 0,
    languages: 0,
    total_revenue: 0,
    paid_subscription_users: 0,
    active_users_man_woman: {
      men: 0,
      woman: 0,
    },
    total_users_man_woman: {
      men: 0,
      woman: 0,
    },
  });

  // Fetch dashboard data
  useEffect(() => {
    async function fetchDashboardData() {
      try {
        const response = await axios.get(
          `${LIVE_URL}/admin/dashboard/get-counts`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          },
        );
        const data = await response.data;
        if (data && data.data) {
          setDashboardData(data.data);
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    }
    if (!loading) {
      fetchDashboardData();
    }
  }, [token, loading]);

  return (
    <>
      <div className={`${styles.dashboard}`}>
        <h2>Report Data</h2>
        <div className={`${styles.dashboard_card}`}>
          <div
            className={`${styles.card}`}
            style={{
              backgroundImage: `linear-gradient(to right, rgba(173, 83, 137, 0.6), rgba(60, 16, 83, 1)), url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
            }}
          >
            <div className={`${styles.title}`}>
              <h3>Total Users</h3>
              <h2>{dashboardData.users}</h2>
            </div>
            <div className={`${styles.image}`}>
              <div className={`${styles.circle}`}>
                <FaUsers />
              </div>
            </div>
          </div>
          <div
            className={`${styles.card}`}
            style={{
              backgroundImage: `linear-gradient(to right, rgba(223, 116, 2, 0.6), rgba(253, 155, 30, 1))
              , url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
            }}
          >
            <div className={`${styles.title}`}>
              <h3>Active Users</h3>
              <h2>{dashboardData.active_users}</h2>
            </div>
            <div className={`${styles.image}`}>
              <div className={`${styles.circle}`}>
                <FaUserCheck />
              </div>
            </div>
          </div>
          <div
            className={`${styles.card}`}
            style={{
              backgroundImage: `linear-gradient(to right, rgba(107, 196, 232, 0.6), rgba(0, 58, 112, 1))
              , url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
            }}
          >
            <div className={`${styles.title}`}>
              <h3>Total Revenue</h3>
              <h2>${dashboardData.total_revenue}</h2>
            </div>
            <div className={`${styles.image}`}>
              <div className={`${styles.circle}`}>
                <GiTakeMyMoney />
              </div>
            </div>
          </div>
          <div
            className={`${styles.card}`}
            style={{
              backgroundImage: `linear-gradient(to right, rgba(178, 69, 146, 0.5), rgba(241, 95, 121, 1)), url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
            }}
          >
            <div className={`${styles.title}`}>
              <h3>Paid Subscribers</h3>
              <h2>{dashboardData.paid_subscription_users}</h2>
            </div>
            <div className={`${styles.image}`}>
              <div className={`${styles.circle}`}>
                <GrNotes />
              </div>
            </div>
          </div>
        </div>
        <UserStatistics />
      </div>
    </>
  );
};

export default Dashboard;
